(function () {
  'use strict';
  const root = document.querySelector('.landing-cure');
  const frame = document.getElementById('cure-quiz');
  const section = document.getElementById('offre');
  const preview = document.getElementById('cure-checkout-preview');
  if (!root || !frame || !section) return;
  const cfg = {
    variantId: Number(root.dataset.variantId) || 0,
    discount: (root.dataset.discountCode || '').trim(),
    simulate: root.dataset.simulate === 'true',
    handle: (root.dataset.productHandle || '').trim()
  };
  const UNIT_CENTS = 2490;
  const PAIR_CENTS = 3735; // one pot at full price + one at half price (GESTE)
  const currency = cents => new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(cents / 100);
  const potsFor = weight => weight < 11 ? 2 : weight <= 23 ? 4 : 6;
  const totalFor = pots => pots === 6 ? 10740 : pots / 2 * PAIR_CENTS;
  let available = null;
  let busy = false;
  let immersive = false, engaged = false;
  const quizDialog = document.createElement('dialog');
  quizDialog.className = 'cure-quiz-screen';
  quizDialog.setAttribute('aria-label', 'Votre cure Vitamii');
  const closeQuiz = document.createElement('button');
  closeQuiz.type = 'button';
  closeQuiz.className = 'cure-quiz-close';
  closeQuiz.textContent = 'Fermer et revenir à l’article';
  const startQuiz = document.createElement('button');
  startQuiz.type = 'button';
  startQuiz.className = 'cure-quiz-start';
  startQuiz.textContent = 'Commencer le quiz';
  frame.before(startQuiz);
  document.body.append(quizDialog);
  quizDialog.append(closeQuiz, frame);
  const screenStyle = document.createElement('style');
  screenStyle.textContent = `
    dialog.cure-quiz-screen{box-sizing:border-box;position:fixed;inset:0;margin:0;width:100%;max-width:none;height:100vh;height:100dvh;max-height:none;padding:0;border:0;border-radius:0;background:#fffdf2;overflow:hidden}
    dialog.cure-quiz-screen[open]{display:flex;flex-direction:column}
    .cure-quiz-screen #cure-quiz{display:block;flex:1;min-height:0;width:100%;max-width:520px!important;height:0!important;margin:0 auto;border:0;background:#fffdf2}
    .cure-quiz-close{flex:none;align-self:center;margin:0;padding:calc(12px + env(safe-area-inset-top)) 16px 12px;background:transparent!important;border:0;color:#112b1e;font:700 14px Nunito,Arial,sans-serif;cursor:pointer}
    .cure-quiz-start{padding:16px 28px;border:0;border-radius:32px;background:#112b1e;color:#fffdf2;font:800 18px Nunito,Arial,sans-serif;cursor:pointer}
    .cure-quiz-screen::backdrop{background:#fffdf2}
  `;
  document.head.append(screenStyle);
  let oldOverflow = '';
  function enterQuiz(){
    engaged = true;
    if (quizDialog.open) return;
    immersive = true;
    oldOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    quizDialog.showModal();
    frame.contentWindow.postMessage({type:'cure-focus'}, '*');
  }
  startQuiz.addEventListener('click', enterQuiz);
  closeQuiz.addEventListener('click', () => quizDialog.close());
  quizDialog.addEventListener('close', () => {
    immersive = false;
    document.documentElement.style.overflow = oldOverflow;
    startQuiz.textContent = 'Reprendre le quiz';
    startQuiz.focus({preventScroll:true});
  });
  function track(name, params) {
    try { document.dispatchEvent(new CustomEvent('vitamii:quiz', {detail: Object.assign({event: name}, params || {})})); } catch (e) {}
    try { if (window.fbq) window.fbq(name === 'InitiateCheckout' ? 'track' : 'trackCustom', name, params || {}); } catch (e) {}
  }

  const stockReady = cfg.handle ?
    fetch('/products/' + encodeURIComponent(cfg.handle) + '.js', {headers: {Accept: 'application/json'}})
      .then(r => r.ok ? r.json() : null)
      .then(product => {
        if (!product || !Array.isArray(product.variants)) return;
        const variant = product.variants.find(v => v.id === cfg.variantId);
        available = !!(variant && variant.available);
        frame.contentWindow.postMessage({type: 'cure-stock', available}, '*');
        return variant;
      })
      .catch(() => null) : Promise.resolve(null);

  document.querySelectorAll('a[href="#offre"]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    enterQuiz();
    if (!immersive) section.scrollIntoView({behavior: 'smooth', block: 'start'});
    frame.contentWindow.postMessage({type: 'cure-focus'}, '*');
  }));

  function showPreview(pots, weight, note, fallback) {
    document.getElementById('cure-preview-selection').textContent = pots + ' pots pour votre chien de ' + weight.toLocaleString('fr-FR') + ' kg.';
    document.getElementById('cure-preview-total').textContent = 'Total : ' + currency(totalFor(pots));
    document.getElementById('cure-preview-note').textContent = note;
    document.getElementById('cure-preview-fallback').hidden = !fallback;
    if (preview && !preview.open) preview.showModal();
  }

  async function checkout(pots, weight) {
    if (busy) return;
    busy = true;
    try {
      if (available === false) {
        showPreview(pots, weight, 'Sa cure est momentanément indisponible. Écrivez-nous à contact@vitamii.fr pour être prévenu du retour en stock.', false);
        return;
      }
      if (cfg.simulate || !cfg.variantId) {
        showPreview(pots, weight, 'Le paiement est simulé dans cet aperçu : aucun panier n’est créé.', false);
        return;
      }
      const variant = await stockReady;
      if (!variant || !variant.available || variant.price !== UNIT_CENTS) {
        showPreview(pots, weight, 'Cette offre ne peut pas être confirmée pour le moment. Rechargez la page pour réessayer.', false);
        return;
      }
      // Shopify creates the exact selection and applies its best eligible discount.
      // Verified: GESTE for 2/4 pots, automatic Poudre dentaire x3 for 6 pots.
      const destination = new URL('/cart/' + cfg.variantId + ':' + pots, window.location.origin);
      if (cfg.discount) destination.searchParams.set('discount', cfg.discount);
      track('InitiateCheckout', {value: totalFor(pots) / 100, currency: 'EUR', num_items: pots, content_ids: [String(cfg.variantId)], content_type: 'product'});
      window.location.href = destination.href;
    } catch (error) {
      showPreview(pots, weight, 'Le panier n’a pas pu être préparé automatiquement. Réessayez, ou ouvrez votre panier pour finaliser la commande.', true);
    } finally {
      busy = false;
    }
  }

  window.addEventListener('message', event => {
    if (event.source !== frame.contentWindow) return;
    const data = event.data;
    if (!data || typeof data !== 'object') return;
    if (data.type === 'cure-height' && Number.isFinite(data.height)) {
      if (!immersive) frame.style.height = Math.max(360, Math.min(1600, data.height + 2)) + 'px';
    }
    if (data.type === 'quiz-step' && [1, 2, 3].includes(data.step)) {
      if (data.step > 1) enterQuiz();

      track('QuizStep', {step: data.step});
      if (data.step === 3 && available !== null) frame.contentWindow.postMessage({type: 'cure-stock', available}, '*');
    }
    if (data.type === 'quiz-end' && Number.isFinite(data.weight) && data.weight >= .5 && data.weight <= 120) {
      const pots = potsFor(data.weight);
      if (data.pots !== pots) return;
      track('QuizComplete', {weight: data.weight, pots});
      checkout(pots, data.weight);
    }
  });
  if (preview) preview.addEventListener('close', () => frame.contentWindow.postMessage({type: 'cure-focus'}, '*'));
})();

